import React from 'react';

import { useHistory } from 'react-router-dom';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IsoIcon from '@material-ui/icons/Iso';
import EditIcon from '@material-ui/icons/Edit';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import PeopleIcon from '@material-ui/icons/People';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { getItemValue } from '../helpers';
import { PAGE_ROUTE, ORDER_BY } from '../../constants';
import { PAGINATION } from '../../constants';
import API from '../../services/api';
import ButtonSort from '../custom/buttonsort';
import CustomAlert from '../custom/alert';
import CustomPaper from '../custom/paper';
import CustomPopover from '../custom/popover';
import CustomSearchAutoComplete from '../custom/searchautocomplete';
import CustomTablePagination from '../custom/tablepagination';
import DraggableDialog from '../draggabledialog';
import Subtitle from '../subtitle';
import Title from '../title';

export default function Component({ children, ...props }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [row, setRow] = React.useState(null);

  const history = useHistory();
  const load = React.useRef(true);

  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const [openDraggableDialog, setOpenDraggableDialog] = React.useState(false);
  const [pagination, setPagination] = React.useState({ perPage: PAGINATION.PER_PAGE });
  const [query, setQuery] = React.useState({});
  const [reload, setReload] = React.useState(false);
  const [removeItem, setRemoveItem] = React.useState({ id: '', name: '', ativo: '' });
  const [sortConfig, setSortConfig] = React.useState({ asc: true, id: '', keys: [] });
  const [state, setState] = React.useState({ data: [], lastPage: 1, page: 1, perPage: 20, total: 0 });

  const profile_id = Number(API.encryptedSessionStorage.getItem('profile_id', API.encryptedSessionStorage.getTokenData().uid));
  const classe_ids = JSON.parse(API.encryptedSessionStorage.getItem('classe_ids', API.encryptedSessionStorage.getTokenData().uid));
  const params = profile_id === 2 ? { classe_ids } : null;

  const handlePopoverOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setRow(item);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setRow(null);
  };

  function componentDidMount() {
    if (load.current) {
      console.log('loading users...');
      API.Users.index({ ...pagination, ...query, ...params })
        .then(onSuccess)
        .catch(onFailure);
    }
    return function componentWillUnmount() {
      load.current = false;
    };
  }

  function onPaginationChanged() {
    API.Users.index({ ...pagination, ...query, ...params })
      .then(onSuccess)
      .catch(onFailure);
    return function paginationChanged() {};
  }

  function onReloadChanged() {
    if (reload) {
      API.Users.index({ ...query, ...params, perPage: pagination.perPage, page: 1 })
        .then(onSuccess)
        .catch(onFailure);
    }
    return function reloadChanged() {
      setReload(false);
    };
  }

  React.useEffect(componentDidMount, []);
  React.useEffect(onPaginationChanged, [pagination]);
  React.useEffect(onReloadChanged, [reload]);

  function onSuccess(response) {
    if (load.current && response.data) {
      // const collator = new Intl.Collator('pt-br', { numeric: true, sensitivity: 'base' });
      // setState({ ...response.data, data: response.data.data.sort((a, b) => collator.compare(a.name, b.name)) });
      // setState({ ...state, ...response.data });
      setState(response.data);
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      setAlert({ open: true, message: error.message });
    }
  }

  function handleAddItem(event) {
    event.preventDefault();
    history.push(PAGE_ROUTE.USERS_STORE);
  }

  async function handleDownloadList(event) {
    event.preventDefault();
    await API.list().catch((error) => {
      setAlert({ open: true, message: error.message });
    });
  }

  const handleClose = () => {
    setOpenDraggableDialog(false);
  };

  // function handleConfirm() {
  //   API.Users.destroy(removeItem.id)
  //     .then(() => {
  //       API.Users.index({ ...pagination, ...query, ...params })
  //         .then(onSuccess)
  //         .catch(onFailure);
  //     })
  //     .catch((error) => {
  //       setAlert({ open: true, message: error.message });
  //     });
  //   handleClose();
  // }

  function handleConfirm() {
    //console.log("Passou aqui")
    API.Users.hide(removeItem.id)
    .then(() => {
      API.Users.index({ ...pagination, ...query, ...params })
        .then(onSuccess)
        .catch(onFailure);
      })
      .catch((error) => {
        setAlert({ open: true, message: error.message });
      });
    handleClose();
  }

  function handleDeleteItemClick(event, item) {
    event.preventDefault();
    setRemoveItem({ id: item.id, name: item.name, ativo: item.ativo });
    setOpenDraggableDialog(true);
  }

  function handleChangePagination(newPagination) {
    setPagination({ ...pagination, ...newPagination });
  }

  return (
    <CustomPaper>
      <CustomPopover open={Boolean(anchorEl)} item={anchorEl} onClose={handlePopoverClose} data={row}></CustomPopover>

      <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })}>
        {alert.message}
      </CustomAlert>
      <DraggableDialog
        open={openDraggableDialog}
        onCancel={handleClose}
        onConfirm={handleConfirm}
        title="Status de cliente"
        body={removeItem.ativo == 1 ? "Deseja alterar o status do cliente '" + removeItem.name +"' para inativo?" :
         "Deseja alterar o status do cliente '" + removeItem.name +"' para ativo?"}
      />
      <Grid container spacing={1}>
        <Grid item>
          <Title>
            <PeopleIcon />
          </Title>
        </Grid>
        <Grid item>
          <Title>Clientes</Title>
        </Grid>
        <Grid item>
          <IconButton size="medium" onClick={handleAddItem}>
            <AddCircleIcon />
          </IconButton>
        </Grid>
        <Grid item xs>
          <IconButton size="medium" onClick={handleDownloadList}>
            <SystemUpdateAltIcon />
          </IconButton>
        </Grid>

        <Grid item xs>
          <CustomSearchAutoComplete
            reload={reload}
            onChange={(value) => {
              setQuery({ ...query, ...params, user_name: value });
              setReload(true);
            }}
            placeholder={'Buscar aluno por nome'}
            value={query.user_name}
            noOptionsText={'Buscar em todas as páginas'}
          />
        </Grid>
        {profile_id === 1 && (
          <Grid item xs>
            <CustomSearchAutoComplete
              reload={reload}
              onChange={(value) => {
                setQuery({ ...query, ...params, school_name: value });
                setReload(true);
              }}
              placeholder={'Buscar aluno por agência'}
              fetch={API.Schools.index}
              value={query.school_name}
            />
          </Grid>
        )}
      </Grid>
      
      <Table size="small">
        <TableHead>
          <TableRow>
            {/* <TableCell align="left"></TableCell> */}
            {/* <TableCell align="left"><Subtitle>Data de criação</Subtitle></TableCell> */}
            <TableCell align="left">
              <ButtonSort
                id={'name'}
                keys={[ORDER_BY.name, ORDER_BY.school_name, ORDER_BY.serie_name, ORDER_BY.classe_name]}
                config={sortConfig}
                setConfig={setSortConfig}
                state={state}
                setState={setState}
              >
                {'Cliente'}
              </ButtonSort>
            </TableCell>
            <TableCell align="left">
              <ButtonSort
                id={'school_id'}
                keys={[ORDER_BY.school_name, ORDER_BY.serie_name, ORDER_BY.classe_name, ORDER_BY.name]}
                config={sortConfig}
                setConfig={setSortConfig}
                state={state}
                setState={setState}
              >
                {'Agência'}
              </ButtonSort>
            </TableCell>
            <TableCell align="left">
              <ButtonSort
                id={'serie_id'}
                keys={[ORDER_BY.serie_name, ORDER_BY.classe_name, ORDER_BY.school_name, ORDER_BY.name]}
                config={sortConfig}
                setConfig={setSortConfig}
                state={state}
                setState={setState}
              >
                {'Série'}
              </ButtonSort>
            </TableCell>
            <TableCell align="center">
              <Subtitle>Editar</Subtitle>
            </TableCell>
            <TableCell align="center" title="Ativo ou inativo">
              <ButtonSort
                id={'ativo'}
                keys={[ORDER_BY.ativo]}
                config={sortConfig}
                setConfig={setSortConfig}
                state={state}
                setState={setState}
              >
                {'Status'}
              </ButtonSort>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {state.data
            // .filter(item => { return item.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0 })
            .map((item, index) => (
              //{console.log(item)}
              <TableRow key={item.id}>
                {/* <TableCell>{index + 1}</TableCell> */}
                {/* <TableCell>{new Date(item.created_at).toLocaleString("pt-BR")}</TableCell> */}
                <TableCell onMouseEnter={(e) => handlePopoverOpen(e, item)} onMouseLeave={handlePopoverClose}>
                  {getItemValue(item, ['ativo']) == 1 ? getItemValue(item, ['name'], '') : <font color="70AD47"> {getItemValue(item, ['name'], '')} <code style={{backgroundColor: "Yellow"}}>INATIVO</code> </font>  } 
                </TableCell>
                <TableCell onMouseEnter={(e) => handlePopoverOpen(e, item)} onMouseLeave={handlePopoverClose}>
                  {getItemValue(item, ['classe']).map((classe, index) => (index > 0 ? '; ' : '') + getItemValue(classe, ['serie', 'school', 'name'], ''))}
                </TableCell>
                <TableCell onMouseEnter={(e) => handlePopoverOpen(e, item)} onMouseLeave={handlePopoverClose}>
                  {getItemValue(item, ['classe']).map((classe, index) => (index > 0 ? '; ' : '') + getItemValue(classe, ['serie', 'name'], '') + ' ' + getItemValue(classe, ['name'], ''))}
                </TableCell>
                <TableCell align="center">
                  <IconButton size="small" onClick={(e) => history.push(`${PAGE_ROUTE.USERS_UPDATE}/${item.id}`)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
                <TableCell align="center">
                  <IconButton size="small" onClick={(e) => handleDeleteItemClick(e, item)}>
                    <IsoIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <CustomTablePagination page={(state.page - 1) | 0} count={state.total} onChange={handleChangePagination} />
    </CustomPaper>
  );
}
